module.exports = __webpack_public_path__ + "static/media/monastery.121da259.jpg";